export const _setReportInfo = (state, action) => {
  if (state.tabs[action.payload.tabID]) state.tabs[action.payload.tabID].reportInfo = action.payload.value;
};

export const _setReportData = (state, action) => {
  if (state.tabs[action.payload.tabID]) state.tabs[action.payload.tabID].reportData = action.payload.value;
};
